import { InternalMessagesRequest } from '../requests/InternalMessagesRequest'
import { ASSIGNEE_TYPE } from '../constants'

class InternalMessageStore {
  internalMessageReceiveList = []
  internalMessageSendList = []
  internalMessageReceiveDetail = {}
  internalMessageSendDetail = {}
  internalMessageListTotalCount = 0
  unreadInternalMessageCount = 0
  replyInternalMessages = []
  pageSize = 10
  pageIndex = 0
  keyword = ''
  queryParams = {
    page: 0,
    size: 10,
    keyword: '',
  }

  setQueryParams = newParams => {
    this.queryParams = { ...this.queryParams, ...newParams }
  }

  setFilter = (filterName, filterValue) => {
    if (typeof filterName !== 'string') return
    this[filterName] = filterValue
  }

  clearInternalMessageReceiveList = () => {
    this.internalMessageReceiveList = []
  }
  clearInternalMessageListFilter = () => {
    this.queryParams = {
      page: 0,
      size: 10,
      keyword: '',
    }
  }

  getInternalMessageReceiveList = async () => {
    return new Promise((resolve, reject) => {
      InternalMessagesRequest.getReceiveList(
        this.queryParams.page,
        this.queryParams.size,
        this.queryParams.keyword
      )
        .then(response => {
          if (this.queryParams.page === 0) {
            this.internalMessageReceiveList = []
          }

          this.internalMessageReceiveList = [
            ...this.internalMessageReceiveList,
            ...response.data?.data,
          ]

          this.internalMessageReceiveList = this.internalMessageReceiveList.map(
            item => {
              const receiverList =
                item.receiver?.map((el, index) => ({
                  id: index,
                  full_name: el.fullname,
                  assignee_type: ASSIGNEE_TYPE.USER,
                  last_date_read: el.updatedTime,
                })) ?? []
              item.receiverList = receiverList
              return item
            }
          )

          this.internalMessageListTotalCount = response.data.total_elements
          this.queryParams.page += 1
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  setInternalMessageList = (messageList, clear = false) => {
    if (clear) {
      this.internalMessageSendList = messageList
    } else {
      this.internalMessageSendList = [
        ...this.internalMessageSendList,
        ...messageList,
      ]
    }
    // Update the total count if necessary
    this.internalMessageListTotalCount = messageList.length
  }

  getInternalMessageSendList = async () => {
    return new Promise((resolve, reject) => {
      InternalMessagesRequest.getSendList(
        this.queryParams.page,
        this.queryParams.size,
        this.queryParams.keyword
      )
        .then(response => {
          this.internalMessageSendList = this.internalMessageSendList.map(
            item => {
              const receiverList =
                item.receiver?.map((el, index) => ({
                  id: index,
                  full_name: el.fullname,
                  assignee_type: ASSIGNEE_TYPE.USER,
                  last_date_read: el.updatedTime,
                })) ?? []
              item.receiverList = receiverList
              return item
            }
          )
          this.internalMessageSendList = [
            ...this.internalMessageSendList,
            ...response.data?.data,
          ]
          this.internalMessageListTotalCount = response.data.total_elements
          this.queryParams.page += 1
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  getReceiveMessageById = async id => {
    return new Promise((resolve, reject) => {
      InternalMessagesRequest.getReceiveMessageById(id)
        .then(response => {
          this.internalMessageReceiveDetail = response.data
          if (response.data.reply_internal_messages?.length > 0) {
            this.replyInternalMessages =
              response.data.reply_internal_messages.sort((a, b) =>
                a.created_time > b.created_time ? 1 : -1
              )
          }
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  getSendMessageById = async id => {
    return new Promise((resolve, reject) => {
      InternalMessagesRequest.getSendMessageById(id)
        .then(response => {
          this.internalMessageSendDetail = response.data
          if (response.data.reply_internal_messages?.length > 0) {
            this.replyInternalMessages =
              response.data.reply_internal_messages.sort((a, b) =>
                a.created_time > b.created_time ? 1 : -1
              )
          }
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  create = async data => {
    return new Promise((resolve, reject) => {
      InternalMessagesRequest.create(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  getInternalMessageUserCodeByInternalMessageCode = async id => {
    return new Promise((resolve, reject) => {
      InternalMessagesRequest.getInternalMessageUserCodeByInternalMessageCode(
        id
      )
        .then(response => {
          resolve(response.data.internal_message_user_code)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  /** Clear Methods */
  clearMessageStore = () => {
    this.internalMessageReceiveList = []
    this.internalMessageSendList = []
    this.internalMessageListTotalCount = 0
    this.replyInternalMessages = []
    this.unreadInternalMessageCount = 0
    this.internalMessageDetail = {}
    this.pageIndex = 0
    this.pageSize = 30
    this.queryParams = {
      page: 0,
      size: 10,
      keyword: '',
    }
  }

  clearInternalMessageList = () => {
    this.internalMessageSendList = []
  }

  clearQueryParams = () => {
    this.queryParams = {
      page: 0,
      size: 10,
      keyword: '',
    }
  }
}

export default new InternalMessageStore()
